import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { combineActions, handleActions } from 'redux-actions';
import { initialize, initializeSuccess, initializeTierTagsSuccess, deinitialize, submitDeviation, deviationSaveError } from './actions';
const handler = handleActions({
    [combineActions(submitDeviation).toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            requestStatus: 'fetching',
            errorMessage: undefined
        }),
    [deviationSaveError.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            requestStatus: 'error',
            errorMessage: action.payload.message
        }),
    [initialize.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            response: undefined,
            requestStatus: 'initializing'
        }),
    [initializeSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            response: _object_spread({}, action.payload),
            requestStatus: 'idle'
        }),
    [deinitialize.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            response: undefined,
            requestStatus: 'uninitialized'
        }),
    [initializeTierTagsSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            tagsByTierId: _object_spread_props(_object_spread({}, state.tagsByTierId), {
                [action.payload.tierId]: action.payload.tags
            })
        })
}, {
    requestStatus: 'uninitialized'
});
export default handler;
